import { render, staticRenderFns } from "./myDialog.vue?vue&type=template&id=dedc7e36&scoped=true&"
import script from "./myDialog.vue?vue&type=script&lang=ts&"
export * from "./myDialog.vue?vue&type=script&lang=ts&"
import style0 from "./myDialog.vue?vue&type=style&index=0&id=dedc7e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedc7e36",
  null
  
)

export default component.exports